import { gql } from "@apollo/client";

export const FETCH_AI_CAPABILITIES = gql`
  query FETCH_AI_CAPABILITIES {
    aiGetCapabilities {
      success
      capabilities
      exampleQuestions
      limitations
      tables {
        tableName
        rowCount
        columns {
          name
          type
        }
      }
    }
  }
`;

export const AI_ASK_QUESTION = gql`
  mutation AI_ASK_QUESTION($question: String!, $conversationId: String) {
    aiAskQuestion(question: $question, conversationId: $conversationId) {
      success
      conversationId
      questionType
      answer # Status text
      rows # Result rows (JSON string)
      sql # Generated SQL
      explanation # SQL explanation
      rowCount
      error # Error message if failed
      unsupported # True if question can't be answered
      reason # Why it's unsupported
    }
  }
`;

export const AI_CONVERSATIONS = gql`
  query AI_CONVERSATIONS($limit: Int) {
    aiConversations(limit: $limit) {
      id
      title
      createdAt
      updatedAt
      messageCount
      user {
        id
        email
      }
    }
  }
`;

export const AI_CONVERSATION = gql`
  query AI_CONVERSATION($id: String!) {
    aiConversation(id: $id) {
      id
      title
      createdAt
      updatedAt
      messageCount
      messages {
        id
        role
        content
        metadata
        createdAt
      }
    }
  }
`;
